export default "__VITE_ASSET__DxKme04Q__"